export default __webpack_public_path__ + "static/media/section2_3.b57c1f01.svg";